var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"info-container"},[_c('shortcuts-info')],1),_c('notes-container',{attrs:{"notes":_vm.notes},on:{"onCreateNote":_vm.onCreateNote,"onUpdateNote":_vm.onUpdateNote,"onDeleteNote":_vm.onDeleteNote}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }